/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core
import useContext from '@/client/context';
import RouterComponent from '@client/services/router/components/router';

/*----------------------------------
- LAYOUT
----------------------------------*/
export default function Layout() {
    const { Router } = useContext();

    return <RouterComponent service={Router} />;
}
